require('./bootstrap');

import './common/global';

// IE11対策用
// import 'babel-polyfill';

// plugins
var Chart = require('chart.js');
import '@fortawesome/fontawesome-free/js/all.min';
import 'jquery-match-height';
import 'jquery-jpostal-ja';
import 'hiraku/js/jquery-hiraku.min';
import 'webp-in-css/polyfill';
import 'jquery-autosize';

// originals
import './common/drawer';
import './common/flash';
import './common/form';
import './common/group';
import './common/tab';
import './common/tippy';
import './common/size';
import './common/swiper';
import './common/favorite';
import './common/reservation';
import './common/message';
import './common/password';
import './common/school';
import './common/footer-fixed';
import './common/jpostal';
import './common/data-href';
import './common/modernizr-custom';
import './common/perfect-scrollbar';
import './common/chart';

// 企業一覧
import './company/detail';

// mojules
import './elements/parts/footer';
import './elements/parts/header';
import './elements/parts/modal';
import './elements/parts/modal-sequential';
import './elements/parts/loading';

// 学生会員登録
import './elements/form/signup';

// 企業マイページ
import './mypage/company/recruit';
import './mypage/company/event';
import './mypage/company/confirm';
import './mypage/company/sort';
import './mypage/company/job-posting';
import './mypage/company/new';
import './mypage/company/profile';
import './mypage/company/edit';
import './mypage/company/sidebar';
import './mypage/company/form';
import './mypage/company/search';
import './mypage/company/keep';
import './mypage/company/general-user';
import './mypage/edit/index';
import './mypage/fileupload';
import './mypage/message/index';
import './mypage/common';
import './mypage/index';
import './mypage/reservation';


import './searchs/index';

import './home';
